/**
 * 跳转登录页：只改 hash，走 Vue Router 的 hash 监听
 * - 不整页重载（避免白屏/极慢）
 * - 不静态引入 router（避免与 request/store 循环依赖导致启动白屏）
 */
export function redirectToLogin() {
	const loginHash = '#/user/login'
	if (window.location.hash === loginHash || window.location.hash === '#/user/login') {
		return
	}
	window.location.hash = loginHash
}
